import { isAppError } from '@/lib/errors';
import type { VerifyTokenResponse } from '@/types/auth';

const USED_CODES = new Set([
  'AUTH_TOKEN_USED',
  'AUTH_TOKEN_ALREADY_USED',
  'AUTH_INVITATION_USED',
  'INVITATION_ALREADY_USED',
  'USER_ALREADY_ACTIVE',
  'USER_ALREADY_REGISTERED',
  'AUTH_USER_ALREADY_EXISTS',
]);

const USED_REASONS = new Set(['USED', 'ALREADY_USED', 'CONSUMED', 'ACTIVATED', 'ACTIVE']);

const normalizeToken = (value?: string | null) =>
  String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');

const looksUsedMessage = (message?: string) => {
  const text = String(message || '').toLowerCase();
  if (!text) return false;
  if (text.includes('already used') || text.includes('already active') || text.includes('already registered')) {
    return true;
  }
  return (
    (text.includes('já') || text.includes('ja ')) &&
    (text.includes('utiliz') || text.includes('ativ') || text.includes('usado') || text.includes('conclu'))
  );
};

export const isInvitationAlreadyUsed = (
  response?: VerifyTokenResponse | null,
  error?: unknown
): boolean => {
  if (response?.used || response?.already_used) return true;
  if (USED_REASONS.has(normalizeToken(response?.reason))) return true;
  if (USED_REASONS.has(normalizeToken(response?.status))) return true;

  if (isAppError(error)) {
    if (USED_CODES.has(normalizeToken(error.code))) return true;
    if (normalizeToken(error.code) === 'AUTH_TOKEN_INVALID') return true;
    if (error.status === 409) return true;
    if (looksUsedMessage(error.message)) return true;
  }

  return false;
};

export const isInvitationExpiredPending = (
  response?: VerifyTokenResponse | null,
  error?: unknown
): boolean => {
  if (response?.expired && !isInvitationAlreadyUsed(response, error)) return true;
  if (normalizeToken(response?.reason) === 'EXPIRED') return true;
  if (normalizeToken(response?.status) === 'EXPIRED') return true;
  return isAppError(error) && normalizeToken(error.code) === 'AUTH_TOKEN_EXPIRED';
};
